const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

export function formatBytes(bytes: number, decimals = 1): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  const k = 1024;
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(k)),
    UNITS.length - 1,
  );
  const value = bytes / Math.pow(k, i);
  const rounded = i === 0 ? Math.round(value) : value.toFixed(decimals);
  return `${rounded} ${UNITS[i]}`;
}
